import { cvBanner } from "./modules/cvBanner";
import { modal } from "./modules/modal";
import { tab } from "./modules/tab";
import { slider } from "./modules/slider";
import { scrollHint } from "./modules/scrollHint";

cvBanner();
modal();
tab();
slider();
scrollHint();
